import { render, staticRenderFns } from "./ProductIncipit.vue?vue&type=template&id=661a6814&scoped=true"
import script from "./ProductIncipit.vue?vue&type=script&lang=ts"
export * from "./ProductIncipit.vue?vue&type=script&lang=ts"
import style0 from "./ProductIncipit.vue?vue&type=style&index=0&id=661a6814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a6814",
  null
  
)

export default component.exports